import type {
  ClientPreferenceFragmentFragment,
  UpdateClientPreferencesMutation,
  UpdateClientPreferencesMutationVariables,
} from "@/__generated__/graphql";
import { UpdateClientPreferencesDocument } from "@/__generated__/graphql";
import { createRequestFactory } from "@/lib/request-factory";
import { useAuthState } from "../auth";
import { transformNotificationSettingsInput } from "@/containers/notifications/notification-settings/lib";

type Response = ClientPreferenceFragmentFragment;

export const useUpdateClientPreferencesStore = createRequestFactory<
  UpdateClientPreferencesMutation,
  Response,
  UpdateClientPreferencesMutationVariables
>({
  method: "mutation",
  graphqlDocument: UpdateClientPreferencesDocument,
  transformFunction: (res) => {
    if (res.updateClientPreferences) {
      return res.updateClientPreferences.preferences;
    }
    throw new Error("Unable to update client preferences");
  },
  onFetchSuccess: ({ autoPay, automatedNotificationEnabled }) => {
    const { setUserInfo } = useAuthState.getState();
    setUserInfo({
      autoPay: autoPay ?? false,
      notificationSettings: transformNotificationSettingsInput(
        automatedNotificationEnabled?.categories,
        automatedNotificationEnabled?.channels,
      ),
    });
  },
});
